export default __webpack_public_path__ + "static/media/a024-10.a0334a47.svg";